import React, { useEffect, useState } from "react";
import { Page } from "../types/Page";
import { Form, Button, Row, Col } from "react-bootstrap";
import { StoreState } from "../redux/reducers";
import { useSelector } from "react-redux";
import "../styles/Form.css";

interface Props {
  onSave: (page: Page) => void;
  initialData?: Page | null;
  clearAfterSubmit: () => void;
}

const initialState: Page = {
  id: 0,
  subModuleId: 0,
  name: "",
};

const PageForm: React.FC<Props> = ({
  onSave,
  initialData,
  clearAfterSubmit,
}) => {
  const [form, setForm] = useState<Page>(initialState);
  const subModules = useSelector((state: StoreState) => state.subModule);

  useEffect(() => {
    if (initialData) {
      setForm({
        ...initialData,
        subModuleId: Number(initialData.subModuleId),
      });
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "subModuleId" ? parseInt(value) : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(form);
    setForm(initialState);
    clearAfterSubmit();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-1">
        <Col className="form-column">
          <Form.Group controlId="subModuleId">
            <Form.Label>Sub-Module</Form.Label>
            <Form.Select
              name="subModuleId"
              value={form.subModuleId ? form.subModuleId.toString() : ""}
              onChange={handleChange}
              required
              style={{
                borderColor: "rgb(215, 210, 210)",
              }}
            >
              <option value="">Select a subModule</option>
              {subModules.map((subModule) => (
                <option key={subModule.id} value={subModule.id}>
                  {subModule.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col className="form-column">
          <Form.Group controlId="name">
            <Form.Label>Page Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md={12}>
          <div className="form-buttons">
            <Button type="submit" className="btn-save">
              {initialData ? "Update" : "Add"} Page
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default PageForm;
